<template>
  <div>
    <vx-card card-border no-shadow :title="$t('request_forms.select_services')">
      <vs-row>
        <div class="w-full vx-col md:w-1/2">
          <label>
            {{ $t('request_forms.service_name') }}
          </label>
          <v-select
            :options="serviceOptions"
            v-model="selectedService"
            :reduce="option => option.value"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full mb-5"
            :clearable="false"
          >
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/2 md:pl-4">
          <label>
            {{ $t('request_forms.number_of_service') }}
          </label>
          <vs-input-number v-model="selectedServiceCount" min="1" class="w-full mb-2 ml-auto mr-auto" />
        </div>
      </vs-row>
      <div class="w-full vx-col">
        <vs-button
          type="border"
          color="success"
          icon-pack="feather"
          icon="icon-plus"
          class="w-full ml-auto mb-base"
          @click="addService"
          :disabled="!validateAddService"
        >
          {{ $t('forms.add') }}
        </vs-button>
      </div>
      <vs-table ref="table" :data="selectedServices">
        <template slot="thead">
          <vs-th>{{ $t('request_forms.service_name') }}</vs-th>
          <vs-th>{{ $t('request_forms.price') }} </vs-th>
          <vs-th>{{ $t('request_forms.number_of_service') }} </vs-th>
          <vs-th>{{ $t('request_forms.total_price') }}</vs-th>
          <vs-th>{{ $t('forms.actions') }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody v-if="data.length">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ $t(`health_services.${subject}.${tr.service}`) }}
              </vs-td>
              <vs-td>
                {{
                  services[tr.service].price > 0 ? services[tr.service].price : $t('request_forms.price_less')
                }}
              </vs-td>
              <vs-td> {{ tr.count | persian_digits }} {{ $t(`units.${tr.unit}`) }} </vs-td>
              <vs-td>
                {{ (parseInt(services[tr.service].price) * parseInt(tr.count)) | toman }}
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(indextr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'SelectSubjectServices',
  props: {
    subject: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedService: '',
      selectedServices: [],
      selectedServiceCount: 1
    }
  },
  computed: {
    services() {
      return this.$store.getters['config/provinceServiceDetails']
        ? this.$store.getters['config/provinceServiceDetails'][this.subject]
        : []
    },
    serviceOptions() {
      const options = []
      if (this.services) {
        for (const [key, value] of Object.entries(this.services)) {
          if (value.price >= 0)
            options.push({
              label:
                this.$t(`health_services.${this.subject}.${key}`) +
                `: ${this.$t('units.each')} ` +
                this.$t(`units.${value.unit}`) +
                ` ${
                  value.price > 0 ? this.$filters.toman(value.price) : this.$t('request_forms.price_less')
                }`,
              value: key
            })
        }
      }
      return options
    },
    validateAddService() {
      return this.selectedService !== '' && this.selectedServiceCount > 0
    }
  },
  watch: {
    selectedServices(val) {
      this.$emit('input', val)
      // console.log(val)
    }
  },
  mounted() {
    this.selectedServices = Object.entries(this.$route.query).map(i => {
      if (this.services[i[0]]) {
        return {
          service: i[0],
          unit: this.services[i[0]].unit,
          count: parseInt(i[1])
        }
      }
      return null
    })
  },
  methods: {
    addService() {
      let exists = false
      for (const s of this.selectedServices) {
        if (s.service === this.selectedService) {
          s.count += parseInt(this.selectedServiceCount)
          exists = true
          break
        }
      }
      if (!exists) {
        this.selectedServices.push({
          service: this.selectedService,
          count: parseInt(this.selectedServiceCount),
          unit: this.services[this.selectedService].unit
        })
      }
      this.selectedService = ''
      this.selectedServiceCount = 1
    },
    openDeleteConfirm(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('button.delete'),
        text: this.$t('messages.are_you_sure'),
        accept: () => {
          delete this.selectedServices.splice(index, 1)
        },
        acceptText: this.$t('button.delete'),
        cancelText: this.$t('button.cancel')
      })
    }
  }
}
</script>
